export const DUMMY_BASE_URL = 'https://example.com';

export const getBaseUrl = () => process.env.REACT_APP_API_URL;

export const setSearchParams = (url: URL, ...objects: any[]) => {
  const searchParams = new URLSearchParams(url.search);
  for (const object of objects) {
    for (const key in object) {
      if (Array.isArray(object[key])) {
        searchParams.delete(key);
        for (const item of object[key]) {
          searchParams.append(key, item);
        }
      } else {
        searchParams.set(key, object[key]);
      }
    }
  }
  url.search = searchParams.toString();
};

export const serializeDataIfNeeded = (value: any, requestOptions: any) => {
  if (value instanceof Set) {
    return JSON.stringify(Array.from(value));
  }
  if (typeof value !== 'string') {
    JSON.stringify(value);
  }
  return value || '';
};

export const toPathString = (url: URL) => url.pathname + url.search + url.hash;
